var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pop-up-main',{attrs:{"title":"经处理的歌"},on:{"closepopup":function($event){return _vm.$emit('closepopup')}}},[_c('div',{staticClass:"content"})])}
var staticRenderFns = []

export { render, staticRenderFns }